import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import Typography from "components/Typography";
import { useMemo } from "react";
import { Line } from "react-chartjs-2";
import CollapsedChart from "./CollapsedChart";
import { LineChartProps } from "./type";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Title,
  Tooltip
);

const BloodPressureLineChart = (props: LineChartProps) => {
  const { chartData, chartsToDisplay, handleToggleDisplayCharts } = props;
  const data = {
    labels: chartData.labels,
    datasets: [
      {
        label: "BP Systolic",
        data: chartData.bps,
        borderColor: "#BD20A3",
        backgroundColor: "#BD20A3",
        fill: false,
        tension: 0.3,
        dates: chartData.date,
      },
      {
        label: "BP Diastolic",
        data: chartData.bpd,
        borderColor: "#039ACA",
        backgroundColor: "#039ACA",
        fill: false,
        tension: 0.3,
        dates: chartData.date,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItem: any) {
            const firstData = tooltipItem[0];
            const dataIndex = firstData.dataIndex;
            const dates = firstData.dataset.dates;
            return `${tooltipItem[0].label} @${dates[dataIndex - 1] || ""}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        position: "right",
      },
    },
  };

  const showChart = useMemo(
    () => chartsToDisplay.includes("bloodPressure"),
    [chartsToDisplay]
  );
  return (
    <>
      {showChart ? (
        <div className="h-[180px] flex ">
          <div className="w-full">
            <Line data={data} options={options as any} />
          </div>
          <div className="w-40 h-44 pl-6">
            <div className="flex items-center justify-between">
              <Typography htmlTag="p" type="pTinny" weight="bold">
                Blood Pressure (mmHg)
              </Typography>
              <button
                onClick={() => handleToggleDisplayCharts("bloodPressure")}
              >
                <img
                  src="/icons/chart-icon.svg"
                  alt="Show Encounter"
                  height={12}
                  width={12}
                  className=""
                />
              </button>
            </div>

            <div className="mt-6">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#BD20A3]"></div>
                <Typography htmlTag="p" type="pTinny">
                  BP Systolic
                </Typography>
              </div>
              <div className="flex items-center gap-2 mt-2">
                <div className="w-2 h-2 rounded-full bg-[#039ACA]"></div>
                <Typography htmlTag="p" type="pTinny">
                  BP Diastolic
                </Typography>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <CollapsedChart
          label="Blood Pressure (mmHg)"
          onButtonClick={() => handleToggleDisplayCharts("bloodPressure")}
        />
      )}
    </>
  );
};

export default BloodPressureLineChart;
